export default function () {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;

  $(`#${widgetName}`).append(
    '<div class="title"><h3><span>Upcoming</span> Events</h3></div><div class="multiFeatureContent"></div>'
  );

  function setCharLimit(el, limit) {
    const text = el.text();
    return text.length > limit ? `${text.substring(0, limit)}...` : text;
  }

  function formatDate(el) {
    const datesMonth = el.text().slice(0, 3);
    const datesDay = el.text().slice(4, 7).replace(',', '');
    el.html(`<span>${datesMonth}</span><span>${datesDay}</span>`);
  }

  function buildItem() {
    const allEventsBtn = $(`#${widgetName} .all-events-btn`);
    allEventsBtn
      .addClass('button')
      .html('VIEW <span> ALL</span>');

    const items = $(`#${widgetName} .featureItem`);
    items.each(function (i) {
      $(this).append(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path class="fa-secondary" opacity=".4" d="M338.7 224L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0 32-32-32-32z"/>
                  <path class="fa-primary" d="M438.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L370.7 256 233.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/>
                </svg>`);
      $(this).find('.featureItemDescription').remove();
      applyAOS($(this), 'flip-up');
      $(this).attr('data-aos-offset', '-200');
      const eventDate = $(this).find('.featureItemDate');
      const eventTitle = $(this).find('.featureItemTitle');
      const eventTitleText = eventTitle.text();
      eventTitle.html(setCharLimit(eventTitle, 50));
      eventTitle.attr('title', eventTitleText);
      formatDate(eventDate);
    });
  }

  $(`#${widgetName}`).MultiScheduleFeature({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID,
    detectIpad: IPADDETECTED,
    isResponsive: false,
    // options
    allEventsLink: true,
    allEventsLinkText: '',
    hasImages: false,
    imageBackground: false,
    lazyLoadImages: true,
    buyNowButton: { visible: false, text: 'BUY NOW' },
    moreButton: { visible: false, text: 'MORE' },
    maxItemsVisible: 5,
    hasDescription: false,
    textContainer: true,
    link: 'all', // options are 'all', 'text', 'image', 'imageAndText', or ''
    attributeOrder: {
      1: 'image',
      2: 'title',
      3: 'date',
      4: 'description',
      5: 'buttons',
    },
    multiFeatureLoaded: function (data) {
      if (data.length < 1) {
        $(`#${widgetName}`).remove();
      } else {
        buildItem();
      }
    },
  });
}

// helper functions
